import { Component, Input, ViewEncapsulation } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { GridContext, GenericColDef } from '../../../models/grid-context';
import { DrObject, DrObjectType, SupportedRegExType } from '../../../models/dr-object';

export interface ComboBoxCellParams extends ICellRendererParams {
    selectedItem: any;
    field: any;
    itemList: any[];
    hasLabelsDisplayed: boolean;
    onChange: (params) => void;
}

@Component({
    standalone: false,
    templateUrl: './combo-box-cell.component.html',
    styleUrls: ['./combo-box-cell.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ComboBoxCellComponent implements ICellRendererAngularComp {
    params: ComboBoxCellParams;
    gridContext: GridContext;
    colDef: GenericColDef;
    automationId: string;
    @Input() isDisabled: boolean;
    drObject = new DrObject(null, SupportedRegExType.METADATAVIEW);
    iconAndLabelsVisibility = {
        editIcon: false,
        existingLabel: false,
        newLabel: false
    }
    sourceValue: string;
    paddingRight: number;

    agInit(params: ComboBoxCellParams): void {
        this.params = params;
        this.gridContext = this.params.context as GridContext;
        this.colDef = this.params.column.getColDef() as GenericColDef;
        let autoId = `${this.colDef.automationId ? (this.colDef.automationId + '-') : ''}grid-cell`;
        let name = '';
        if (this.colDef.headerName) {
            name = this.colDef.headerName.replace(/%/g, 'percent').replace(/[^a-zA-Z0-9-_ ]/gi, '');
        }
        if (name) {
            autoId += `-${name.replace(/([a-z])([A-Z])/g, '$1-$2').replace(/\s+/g, '-').toLowerCase()}`;
        }
        this.automationId = autoId;
        //this.iconAndLabelsVisibility.editIcon = false;
        this.sourceValue = this.params.data[this.params.field];
        this.paddingRight = 10;
        if (this.params.data.popoverError.isError) {
            this.iconAndLabelsVisibility.editIcon = true;
            this.iconAndLabelsVisibility.existingLabel = false;
            this.iconAndLabelsVisibility.newLabel = false;
        } else {
            this.setLabelVisibility(this.params.data.newValue);
        }
        this.loadPopoverWithTimeout(params.data.popoverError.popover);
    }

    refresh(): boolean {
        return false;
    }

    validateName(name: string): void {
        const empty = DrObject.isEmpty(name);
        if (empty) {
            this.params.data.popoverError.message = 'Please select or enter a value';
            this.params.data.popoverError.type = 'error';
            this.params.data.popoverError.placement = 'left';
            this.params.data.popoverError.isError = true;
            this.loadPopoverWithTimeout(true);
        } else {
            const errorMessage = this.drObject.uiValidateName(name);
            if (errorMessage?.length > 0) {
                this.params.data.popoverError.message = errorMessage;
                this.params.data.popoverError.type = 'error';
                this.params.data.popoverError.placement = 'bottom';
                this.params.data.popoverError.isError = true;
                this.loadPopoverWithTimeout(true);
            } else {
                this.params.data.popoverError.isError = false;
                this.loadPopoverWithTimeout(false);
            }
        }
    }

    loadPopoverWithTimeout(popover: boolean): void {
        this.params.data.popoverError.popover = false;
        if (popover) {
            setTimeout(() => {
                this.params.data.popoverError.popover = popover;
            });
        }
    }

    lengthValidation() {
        if (this.params.data.newValue.length > 100) {
            this.params.data.newValue = this.params.data.newValue.substring(0, 100);
            this.params.data.popoverError.message = 'Up to 100 characters are allowed.' + '\nOne or more characters were trimmed at the end.';
            this.params.data.popoverError.type = 'info';
            this.params.data.popoverError.placement = 'bottom';
            this.params.data.popoverError.isError = false;
            this.loadPopoverWithTimeout(true);
        }
    }

    onFocusChanged = (item: any): void => {
        const newItemValue = item.trim();
        if (newItemValue !== item) {
            this.onChange(newItemValue);
        }
    }

    onChange = (name: string): void => {
        this.validateName(name);
        this.paddingRight = 10
        if (this.params.data.popoverError.isError) {
            this.iconAndLabelsVisibility.editIcon = true;
            this.iconAndLabelsVisibility.existingLabel = false;
            this.iconAndLabelsVisibility.newLabel = false;
            this.paddingRight += 15;
        } else {
            this.setLabelVisibility(name);
        }
        this.params.data.newValue = name;
        if (this.params.onChange) {
            this.params.onChange(this.params);
        }
    }

    setLabelVisibility(name) {
        if (this.sourceValue !== name) {
            this.iconAndLabelsVisibility.editIcon = true;
            this.paddingRight += 15;
        } else {
            this.iconAndLabelsVisibility.editIcon = false;
        }
        const foundItem = this.params.itemList.find(el => el.toLowerCase() === name.toLowerCase());

        if (foundItem) {
            if (foundItem === name) {
                this.paddingRight += 50;
                this.iconAndLabelsVisibility.existingLabel = true;
                this.iconAndLabelsVisibility.newLabel = false;
                this.params.data.popoverError.isError = false;
                this.loadPopoverWithTimeout(false);

            } else {
                this.paddingRight += 50;
                this.iconAndLabelsVisibility.existingLabel = true;
                this.iconAndLabelsVisibility.newLabel = false;
                this.params.data.popoverError.message = '\"' + name + '\" already exists."'
                this.params.data.popoverError.isError = true;
                this.loadPopoverWithTimeout(true);

            }
        } else {
            this.paddingRight += 28;
            this.iconAndLabelsVisibility.existingLabel = false;
            this.iconAndLabelsVisibility.newLabel = true;
            this.params.data.popoverError.isError = false;
            this.loadPopoverWithTimeout(false);
        }
    }
}
